module.exports = __webpack_public_path__ + "static/img/2.26b17dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/2.jpg
// module id = cXqj
// module chunks = 70